// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"09f82cc8","732":"4f1d553c","977":"eab49182"}[chunkId] + ".chunk.js";
};